module.exports = __webpack_public_path__ + "static/img/ARCHIE-TAYLOR.b9c3ce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARCHIE-TAYLOR.jpg
// module id = BM0p
// module chunks = 0